import React, { Component } from 'react';
import RouteElement from './RouteElement';
import { getHeaderRoutes } from '../../config/routeConfig';
import { cookie } from '../../utilities/Utility';

class Home extends Component {
	render() {
		return <div className="subpage_wrapper">
			<div className="subpage_wrapper_element">
				<h2 className="subpage_content_header">
					Home
				</h2>
				<div className="subpage_content_contents">
					{this.routes()}
				</div>
			</div>
		</div>;
	}

	routes = () => {
		const { routeTrigger } = this.props;
		let dispatchUserType = cookie.get('userType');
		const headerRoutes = getHeaderRoutes(dispatchUserType);
		return headerRoutes.mainRoutes.map((route) => {
			const conf = {
				key: route.routeName,
				routeClick: routeTrigger(route.routeName),
				...route
			}
			return <RouteElement 
				{...conf}
			/>
		})
	}
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/home/Home.jsx